import React, { useMemo, useEffect, useState } from 'react';
import clsx from 'clsx';
import style from './style.module.scss';
import { timeUtils } from 'utils/timeUtil';
import SportsTeamLogo from 'components/teamLogo';
import { observer } from 'mobx-react';
import { StringUtil } from 'utils/stringUtil';
import { FormatUtil } from 'utils/formatUtil';

const HockeyTracker = observer(({ item, isPopup }) => {
  const { getTracker, typeData, cheerCount } = item;

  const onClickDetail = () => {
    window.open(
      `/match/hockey/${item.id}`,
      `detail_${item.id}`,
      'width=1000px,height=901px,scrollbars=yes'
    );
  };

  const innerDom = () => {
    switch (getTracker.status) {
      case 'progress':
        return <InnerProgress typeData={typeData} />;

      case 'final':
        return (
          <InnerFinal
            winnerTeam={item.winnerTeam}
            id={item.id}
            gameStatus={item.gameStatus}
            boardFlag={item.boardFlag}
            isPopup={isPopup}
          />
        );

      case 'ready':
        return (
          <InnerReady
            startDatetime={item.getStartDateTime}
            originStartDateTime={item.startDatetime}
          />
        );

      default:
        return (
          <InnerReady
            startDatetime={item.getStartDatetime}
            originStartDateTime={item.startDatetime}
          />
        );
    }
  };

  return (
    <div
      onClick={onClickDetail}
      className={clsx(style.tracker, style[getTracker.class])}
    >
      {innerDom()}
      {(getTracker.status === 'progress' || getTracker.status === 'ready') &&
        (item.availableBroadcast.playText.length > 0 ? (
          <div className={style.text_relay}>
            <div
              className={style.cont}
            >{`${item.availableBroadcast.teamName} ${item.availableBroadcast.playText}`}</div>
          </div>
        ) : null)}
      {cheerCount >= 100 && (
        <div className={style.cheer_count}>
          {FormatUtil.numberUnitConvert(cheerCount)}
        </div>
      )}
    </div>
  );
});

const InnerProgress = ({ typeData }) => {
  // const {} = typeData;
  return <div className={style.inner}></div>;
};

const InnerFinal = ({ id, gameStatus, boardFlag, winnerTeam, isPopup }) => {
  const finalMessage = useMemo(() => {
    if (gameStatus === 'FINAL') {
      if (winnerTeam.difference === 0) {
        return '무승부';
      } else if (winnerTeam.isShootout) {
        return '슛아웃 승리';
      } else {
        return `${winnerTeam.difference} 점차 승리`;
      }
    } else if (gameStatus === 'CANCEL' || gameStatus === 'SUSPENDED') {
      return '경기 취소';
    } else if (gameStatus === 'DELAY' || gameStatus === 'POSTPONED') {
      return '연기';
    } else if (gameStatus === 'PENDING' || gameStatus === 'CUT') {
      return '경기 중단';
    } else if (gameStatus === 'PAUSE') {
      return '일시 중단';
    }
  }, [gameStatus, winnerTeam]);

  const status = useMemo(() => {
    if (gameStatus === 'FINAL') {
      return winnerTeam.difference === 0 ? 'draw' : 'win';
    } else {
      return StringUtil.lower(gameStatus);
    }
  }, []);

  return (
    <div className={style.inner}>
      <SportsTeamLogo
        imgSize={'65'}
        imgUrl={status === 'win' ? winnerTeam.team.imgPath : null}
        isLazy={false}
        status={status}
        id={id}
      />
      <p className={style.info}>
        <em className={style.team}>{winnerTeam.team.name}</em>
        <em className={style.tx}>{finalMessage}</em>
      </p>
    </div>
  );
};

const InnerReady = ({ startDatetime, originStartDateTime }) => {
  const [timeView, setTimeView] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState({});

  useEffect(() => {
    const intervalTime = setInterval(() => {
      setTimeRemaining(timeUtils.getTimeRemaining(originStartDateTime));
    }, 1000);

    return () => {
      clearInterval(intervalTime);
    };
  }, []);

  useEffect(() => {
    if (
      timeRemaining.days === 0 &&
      timeRemaining.hours === 0 &&
      timeRemaining.minutes <= 60
    ) {
      setTimeView(true);
    } else {
      setTimeView(false);
    }
  }, [timeRemaining, originStartDateTime]);

  return (
    <div className={style.inner}>
      <p className={style.time}>
        <em className={clsx(style.num, timeView && style.active)}>
          {timeView
            ? `00:${timeRemaining.minutes}:${timeRemaining.seconds}`
            : startDatetime}
        </em>
        <em className={style.tx}>{timeView ? '후' : ''} 경기 시작</em>
      </p>
    </div>
  );
};

export default HockeyTracker;
